export default {
  isLoading: false,
  error: null,
  counterparties: [],
}
